import { createAsyncThunk } from '@/redux/createAsyncThunk';
import {
    AbsenteeBidDetails,
    SubmitAbsenteeBidParams,
    SubmitAbsenteeBidPayload,
} from '@/redux/modules/absenteeBid/absenteeBid.types';
import { getAuthToken } from '@/redux/modules/account/user/user.selectors';
import { AnalyticsTypes, getPlacedBidAnalytics, trackConversionForAlgolia } from '@/redux/modules/analytics';
import { fetchAllBidderBiddingInfoIfNeeded } from '@/redux/modules/bidder/biddingInfoAll/bidderBiddingInfoAll.actions';
import { fetchBidLimitBalanceIfNeeded } from '@/redux/modules/bidLimit/bidLimit.actions';
import { isUiMobile } from '@/redux/modules/browser';
import { getDeployment } from '@/redux/modules/config';
import { emptyLocation } from '@/utils/test/locationMock';

import { postPlaceAbsenteeBid } from './absenteeBid.api';

export const submitAbsenteeBid = createAsyncThunk<SubmitAbsenteeBidPayload, SubmitAbsenteeBidParams>(
    'la/ui/absenteeBid/submitAbsenteeBid',
    async ({ absenteeBidDetails, location }, { dispatch, getState }) => {
        const state = getState();
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);

        const isMobile = isUiMobile(state);
        const details: AbsenteeBidDetails = {
            ...absenteeBidDetails,
            client: 'React',
            deviceType: isMobile ? 'Mobile' : 'Desktop',
        };

        const response = await postPlaceAbsenteeBid({
            authToken,
            deployment,
            details: details,
        });

        await dispatch(trackConversionForAlgolia(details.itemId));

        const fetchBidLimitBalance = await dispatch(
            fetchBidLimitBalanceIfNeeded({
                catalogId: details.catalogId,
                force: true,
                itemId: details.itemId,
            })
        );
        const fetchAllBidderBidding = await dispatch(fetchAllBidderBiddingInfoIfNeeded(true));
        await Promise.allSettled([fetchBidLimitBalance, fetchAllBidderBidding]);

        getPlacedBidAnalytics(
            getState(),
            details.itemId,
            details.bidAmount,
            AnalyticsTypes.Track.PlaceAbsenteeBid,
            location ?? emptyLocation
        );

        return {
            meta: {
                actionTime: Date.now(),
                itemId: details.itemId,
            },
            payload: response,
        };
    }
);
